import { Box, Divider, Stack, Typography } from "@mui/material";
import { useState } from "react";

import BorderLinearProgress from "@mui/material/LinearProgress";

import { ReactComponent as Piggybank } from "../../../assets/icon/piggybank.svg";
import { ReactComponent as ChildrenMarriage } from "../../../assets/icon/childrenmarriage.svg";
import { ReactComponent as ChildrenEducation } from "../../../assets/icon/childreneducation.svg";
import { colors } from "../../../style/color/colors";

import { String } from "../../../constants/Strings";
import ChildGoalComponent from "../ChildGoalCardComponent";
import { fonts } from "../../../style/fonts/fonts";

const GoalCard = ({ goal }) => {
  const goalCurrentValue = Number(goal.currentValueAmount);
  const goalTargetAmount = Number(goal.targetValueAmount);

  let currentPercentage;
  if (goalTargetAmount > 0) {
    currentPercentage = (goalCurrentValue / goalTargetAmount) * 100; 
  }
  if (goalTargetAmount < goalCurrentValue) {
    currentPercentage = 100;
  }

  return (
    <Box
      sx={{
        mt: "20px",
        border: "0.60px #A8ABB1 solid",
        borderRadius: 5,
        marginBottom: "20px",
      }}
    >
      <Box
        sx={{ ml: "10px", display: "flex", justifyContent: "space-between" }}
      >
        <Box
          sx={{ p: "10px", display: "flex", justifyContent: "space-between" }}
        >
          <goal.icon style={{ width: "20px", height: "20px" }} />
          <Stack sx={{ ml: "10px" }}>
            <Typography
              sx={{
                color: colors.NeutralDark700,
                fontSize: 13,
                fontFamily: fonts.manrope,
                fontWeight: "700",
              }}
            >
              {goal.name}
            </Typography>
            <Typography
              sx={{
                color: colors.NeutralsMidN300,
                fontSize: 10,
                fontFamily: fonts.manrope,
                fontWeight: "700",
              }}
            >
              {`Time: ${goal.time}`}
            </Typography>
          </Stack>
        </Box>
      </Box>
      <Divider sx={{ mt: "10px" }} />
      {goal.currentValueAmount !== null && goal.targetValueAmount !== null ? (
        <Box sx={{ p: 1 }}>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Typography>
              ₹{" "}
              {goalCurrentValue.toLocaleString("en-IN", {
                maximumFractionDigits: 0,
              })}
            </Typography>
            <Typography>
              ₹{" "}
              {goalTargetAmount.toLocaleString("en-IN", {
                maximumFractionDigits: 0,
              })}
            </Typography>
          </Box>
          <Box sx={{ width: "100%", mt: 2, borderRadius: 2 }}>
            <BorderLinearProgress
              variant="determinate"
              value={currentPercentage}
              sx={{
                borderRadius: 10,
                height: "7px",
                border: "1px solid colors.AntiFlashWhite",
                backgroundColor: colors.AntiFlashWhite,
                "& .MuiLinearProgress-bar": {
                  backgroundColor: colors.ExtendedpalettesSummerSkySS800,
                },
              }}
            />
          </Box>
          <Box sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}>
            <Typography
              sx={{
                color: colors.NeutralsMidN300,
                fontSize: 10,
                fontFamily: fonts.manrope,
                fontWeight: "700",
              }}
            >
              {String.Dashboard.currentandtarget.CurrentValue}
            </Typography>
            <Typography
              sx={{
                color: colors.NeutralsMidN300,
                fontSize: 10,
                fontFamily: fonts.manrope,
                fontWeight: "700",
              }}
            >
              {String.Dashboard.currentandtarget.TargetAmount}
            </Typography>
          </Box>
        </Box>
      ) : (
        ""
      )}

      {goal.dashboardChildren && goal.dashboardChildren.length > 0 && (
        <Box sx={{ mt: 2, pl: 2, pr: 2, pb: 2 }}>
          {goal.dashboardChildren.map((child, index) => (
            <ChildGoalComponent key={index} child={child} />
          ))}
        </Box>
      )}
    </Box>
  );
};

function SavingGoalCards({ goals, editVal }) {
  const [onEditClick] = useState(false);

  const icons = {
    "Child Education": ChildrenEducation,
    "Child's Marriage": ChildrenMarriage,
    Travel: Piggybank,
    House: Piggybank,
    Home: Piggybank,
    Retirement: Piggybank,
    Others: Piggybank,
    Car: Piggybank,
    Business: Piggybank,
  };
  const goalArray = goals.map((goal) => {
    return { ...goal, icon: icons[goal.name] };
  });

  return (
    <>
      <Box>
        <Box
          sx={{ display: "flex", justifyContent: "space-between", mt: "30px" }}
        >
          <Box>
            <Typography
              sx={{
                color: colors.PrimaryWoodSmoke,
                fontSize: 16,
                fontFamily: fonts.manrope,
                fontWeight: "700",
              }}
            >
              {String.Dashboard.mainDashboard.SavingGoals}
            </Typography>
            <Typography
              sx={{
                color: colors.NeutralDark700,
                fontSize: 12,
                fontFamily: fonts.manrope,
                fontWeight: "500",
              }}
            >
              {
                String.Dashboard.mainDashboard
                  .Goalsareprioritisedbasedontheirtimesensitivity
              }
            </Typography>
          </Box>
        </Box>

        {goalArray.map((goal, index) => (
          <GoalCard key={index} goal={goal} editClick={onEditClick} />
        ))}
      </Box>
    </>
  );
}

export default SavingGoalCards;
